import numeral from 'numeral';

export type Currency = 'AUD' | 'HKD' | 'NZD' | 'SGD' | 'USD' | 'ZAR';

export const CountryCurrency: { [country: string]: Currency } = {
  AU: 'AUD',
  HK: 'HKD',
  NZ: 'NZD',
  SG: 'SGD',
  US: 'USD',
  ZA: 'ZAR',
};

export const CurrencyLocale = {
  AUD: 'en-AU',
  HKD: 'zh-HK',
  NZD: 'en-NZ',
  SGD: 'en-SG',
  USD: 'en-US',
  ZAR: 'en-ZA',
};

export const formatCurrency = (amount: number, currency: Currency): string =>
  new Intl.NumberFormat(CurrencyLocale[currency], {
    style: 'currency',
    currency,
  }).format(amount);

export const toCurrency = (amount: number, currency: Currency): string =>
  formatCurrency(numeral(amount).divide(100).value() ?? 0, currency);

export const fromCurrency = (amount: string | number): number => {
  try {
    return Number(
      numeral(amount || '0')
        .multiply(100)
        .format('0'),
    );
  } catch (e) {
    return 0;
  }
};

export const formatCurrencyWithCents = (amount: number): string => numeral(amount).format('0.00');
